import pick from "lodash/pick";
import { MSDriveItem } from "../../../types/ms-graph";

export const toTree = (item: any): any => {
  const sortItems = (items: any[]) => {
    return items.sort((a, b) => {
      // Nếu cả hai đều có docPosition, sắp xếp theo docPosition
      if (a.position !== null && a.position !== undefined && b.position !== null && b.position !== undefined) {
        return a.position - b.position;
      }

      // Nếu chỉ a có docPosition, a lên trước
      if (a.position !== null && a.position !== undefined) return -1;

      // Nếu chỉ b có docPosition, b lên trước
      if (b.position !== null && b.position !== undefined) return 1;

      // Nếu cả hai đều không có docPosition, sắp xếp theo name
      return a.title.localeCompare(b.title);
    });
  };

  const sortedItems = sortItems(item);

  return sortedItems.map((item: any) => ({
    id: item.key,
    name: item.title,
    docPosition: item.position,
    children: item.children ? toTree(item.children) : [],
    title: item.title,
    key: item.key,
  }));
};

export const compactData = (data: any[]) => {
  const pickFieldNames = ["docPosition"];
  const pickDriveItemFieldNames = ["id", "createdBy", "createdDateTime", "name", "parentReference", "folder"];
  return data.map((item) => ({
    ...(pick(item.driveItem, pickDriveItemFieldNames) as MSDriveItem),
    ...(pick(item.fields, pickFieldNames) as { docPosition: number }),
    listId: item.id,
  }));
};

export const toFlat = (arr: any[], parentKey?: string): any =>
  arr
    .map((item) => [
      {
        ...item,
        parentKey,
      },
      ...(item.children ? toFlat(item.children, item.key) : []),
    ])
    .flat();
